import React, { useEffect, useState } from 'react';

import one from '../../../assets/images/previewStep/1-big.svg';
import two from '../../../assets/images/previewStep/2-big.svg';
import three from '../../../assets/images/previewStep/3-big.svg';
import { useUserData } from '../../../components/UserData';
import { getProjectInfo } from '../../../assets/apis/innovate';
import Basic from './basic';
import Addition from './addition';
import ApplyInfo from './applyInfo';
import '../index.scss';
import './index.scss';

const img_step = [one, two, three];

export default (props) => {
  const { startOb, projectNo } = props;
  const [detail, setDetail] = useState(null);
  const { inoProjectConfigId } = useUserData();
  useEffect(() => {
    if (inoProjectConfigId || projectNo) {
      const params = projectNo ? { projectNo } : { projectConfigId: inoProjectConfigId };
      getProjectInfo(params)
        .then((res) => {
          setDetail(res);
        });
    }
  }, [projectNo, inoProjectConfigId]);

  useEffect(() => {
    startOb && startOb();
  }, [detail]);
  return detail ? (
    <div style={{ display: 'flex', flexDirection: 'column' }} className="preview-content innovate-preview-content">
      <div className="h2-title-wrap">
        <img src={img_step[0]} alt="" />
        <h2 id="base" className="catalogue-tag">基础信息</h2>
      </div>
      <Basic detail={detail.baseInfo} />
      <div className="h2-title-wrap">
        <img src={img_step[1]} alt="" />
        <h2 id="addition" className="catalogue-tag">附加信息</h2>
      </div>
      <Addition detail={detail.additionInfo} />
      <div className="h2-title-wrap">
        <img src={img_step[2]} alt="" />
        <h2 id="apply" className="catalogue-tag">申报信息</h2>
      </div>
      <ApplyInfo detail={detail.applyInfo} />
    </div>
  ) : null;
};
